/**
 * SplashScreen — shown briefly after a successful Google sign-in before the
 * main dashboard appears.
 *
 * Plays a short animation:
 *   logo_hand_button.png bounces in → "Praxys" fades up → "makes better" fades in
 * then calls onDone after ~2.4 s.
 */
import React, { useEffect } from 'react';
import logoHandBtn from '../assets/logo_hand_button.png';

interface Props {
  onDone: () => void;
}

const SplashScreen: React.FC<Props> = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 2400);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div className="praxys-splash-shell">
      <div className="praxys-splash-content">
        <div className="praxys-splash-logo-wrap">
          <img src={logoHandBtn} alt="Praxys" className="praxys-splash-logo" />
        </div>
        <div className="praxys-splash-name">Praxys</div>
        <div className="praxys-splash-tagline">makes better</div>
      </div>
    </div>
  );
};

export default SplashScreen;
